import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TypeService } from '../../service/lcontype/type.service';
// import { TestQueryService } from "../../test-query.service";
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { TestWeiyunService } from '../../test.weiyun.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit {
  // @Input() sider:any;
  @Input() getval: any;
  public line: any;
  public x: any;
  public column: any;
  public arr = [];
  // Wu 之前设置成 3  3 导致只能显示10个图形
  posData: any = { x: 5, y: 5 };
  picNewData:any;
  moduleData: any;
  showDataTime:any = "年";
  values: any = {
    refresh:this.srv.changRefresh,
    picheight: "800",
    picDec: this.posData,
    dates: this.showDataTime,
    data: [],
    status:"created",
    newpicData: {preservation:false,rootIp:this.ml.rootIp},
  }
  constructor(public srv: TypeService,public ml:TestWeiyunService,public http:HttpClient) { }

  ngOnInit() {
    console.log(this.values)
    this.getModules();
    // 发送几行几列
    this.srv.getline().subscribe((result) => {
      this.posData = result;
      this.values = {
        refresh:this.srv.changRefresh,
        picheight: "1200",
        picDec: this.posData,
        newpicData: {picnewid:this.ml.newData.picnewid,preservation:false,title:this.ml.newData.title,rootIp:this.ml.rootIp,titleColor:this.ml.bgColor},
        dates: this.showDataTime,
        data: this.arr,
        status:"created"
      }
    })
    // 修改自动刷新时间
    this.srv.getrefresh().subscribe((result) => {
      this.srv.changRefresh = result;
      this.values = {
        refresh: this.srv.changRefresh,
        picheight: "1200",
        picDec: this.posData,
        newpicData: {picnewid:this.ml.newData.picnewid,preservation:false,title:this.ml.newData.title,rootIp:this.ml.rootIp,titleColor:this.ml.bgColor},
        dates: this.showDataTime,
        data: this.arr,
        status:"created"
      }
    })
    // 修改展示内容时间
    this.srv.getShowTime().subscribe((result) => {
      this.showDataTime = result;
      this.values = {
        refresh: this.srv.changRefresh,
        picheight: "1200",
        picDec: this.posData,
        newpicData: {picnewid:this.ml.newData.picnewid,preservation:false,title:this.ml.newData.title,rootIp:this.ml.rootIp,titleColor:this.ml.bgColor},
        dates: this.showDataTime,
        data: this.arr,
        status:"created"
      }
    })
    // 添加图形
    this.srv.getrun().subscribe((res) => {
      this.arr.push(res);
      // 如果 x * y 的值小于返回的对象,如果面板超过9个他还是会增加面板 但这里直接导致上边的push报错
      if(this.posData.x*this.posData.y < this.arr.length){
        return;
      }
      this.values = {
        refresh:this.srv.changRefresh,
        picheight: "1200",
        picDec: this.posData,
        newpicData: {picnewid:this.ml.newData.picnewid,preservation:false,title:this.ml.newData.title,rootIp:this.ml.rootIp,titleColor:this.ml.bgColor},
        dates: this.showDataTime,
        data: this.arr,
        status:"created"
      }
    });
    // 修改参数
    this.srv.getattribute().subscribe((res)=>{

      res.datas.forEach((v:any,i:any)=>{
        if(v.tip=="max"&&v.value==""){
          v.value = "auto";
        }
        this.arr[res.current][v.tip] = v.value;
      })

      // for(let item in res.datas){
      //   if(item=="spans"){
      //     this.arr[res.current][item] = Number(res.datas[item]);
      //   }else{
      //     this.arr[res.current][item] = res.datas[item];
      //   }
      // }
      this.values={
        refresh:this.srv.changRefresh,
        picheight:"1200",
        picDec:this.posData,
        newpicData:{picnewid:this.ml.newData.picnewid,preservation:false,title:this.ml.newData.title,rootIp:this.ml.rootIp,titleColor:this.ml.bgColor},
        dates:this.showDataTime,
        data:this.arr,
        status:"created"
    }
    })
    // 删除图形
    this.srv.getdeletepic().subscribe((res)=>{
      this.arr.splice(res,1);
      this.srv.number1.splice(res,1);
      this.values={
        refresh:this.srv.changRefresh,
        picheight:"1200",
        picDec:this.posData,
        picType:"scripteds",
        newpicData: {picnewid:this.ml.newData.picnewid,preservation:false,title:this.ml.newData.title,rootIp:this.ml.rootIp,titleColor:this.ml.bgColor},
        dates:this.showDataTime,
        data:this.arr,
        status:"created"
      }
    })
    // 新建页面
    this.srv.getpage().subscribe((res)=>{
      this.srv.number1 = [];
      this.arr = [];
      this.values={
        refresh:this.srv.changRefresh,
        picheight:"1200",
        picDec:this.posData,
        picType:"scripteds",
        newpicData: {picnewid:this.ml.newData.picnewid,preservation:false,title:this.ml.newData.title,rootIp:this.ml.rootIp,titleColor:this.ml.bgColor},
        dates:this.showDataTime,
        data:this.arr,
        status:"created"
      }
    })
    // 是否保存
    this.srv.getpre().subscribe((res) => {
      this.values = {
        refresh:this.srv.changRefresh,
        picheight: "1200",
        picDec: this.posData,
        newpicData: {picnewid:this.ml.newData.picnewid,preservation: res ,title:this.ml.newData.title,rootIp:this.ml.rootIp,titleColor:this.ml.bgColor},
        dates: this.showDataTime,
        data: this.arr,
        status:"created"
      }
    })
    // 打开之前储存
    this.srv.getopen().subscribe((res) => {
      this.srv.saveFlag = true;
      this.arr = res.data;
      this.srv.number1 = [];
      res.data.forEach((value,index)=>{
        let mName = "";
        this.moduleData.forEach((res:any,current:any) => {
          if(res.id==value.state){
            mName = res.modelName;
          }
        });
      let newtip = []
      newtip.push(
        {name:"图表标题",value:value.name,tip:"name"},
        {name:"图表宽度",value:value.spans,tip:"spans"},
        {name:"图表高度",value:value.oneHeight,tip:"oneHeight"},
        {name:"图表数据",value:mName,tip:"state"}
      );
      if(res.oneType=="barchart"){
        newtip.push(
          {name:"数据单位",value:value.unit,tip:"unit"},
          {name:"最大值",value:value.max,tip:"max"},
        )
      }
      // else if(res.oneType=="piechart"){
      //   newtip.push(
      //     {name:"饼图形状",value:value.types,tip:"types"},
      //   )
      // }
      this.srv.number1.push(newtip)

        // this.srv.number1.push({name:value.name,spans:value.spans,oneHeight:value.oneHeight});
        // this.srv.number1.push(
        //   [{name:"图表标题",value:value.name,tip:"name"},{name:"图表宽度",value:value.spans,tip:"spans"},{name:"图表高度",value:value.oneHeight,tip:"oneHeight"},{name:"图表数据",value:value.state,tip:"state"}],
        // );
      })
      this.values = {
        refresh: res.refresh,
        picheight: res.picheight,
        picDec: res.picDec,
        newpicData: res.newpicData,
        dates: res.dates,
        data: this.arr,
        status:res.status
      }
      console.log(this.values)
    })
    // 是否发布
    this.srv.getrelease().subscribe((res)=>{
      // this.arr.push(res)
      this.values={
        refresh:this.srv.changRefresh,
        picheight:"1200",
        picDec:this.posData,
        newpicData: {picnewid:this.ml.newData.picnewid,preservation: this.srv.saveFlag ,title:this.ml.newData.title,rootIp:this.ml.rootIp,titleColor:this.ml.bgColor},
        dates:this.showDataTime,
        data:this.arr,
        status:"publish"
      }
    })
    // 更新背景
    this.srv.getBasic().subscribe((res)=>{
      this.values={
        refresh:this.srv.changRefresh,
        picheight:"1200",
        picDec:this.posData,
        newpicData: {picnewid:this.ml.newData.picnewid,preservation: res ,title:this.ml.newData.title,rootIp:this.ml.rootIp,titleColor:this.ml.bgColor},
        dates:this.showDataTime,
        data:this.arr,
        status:"created"
      }
    })

  }
  // this.srv.values();


  // 获取所有存储的module
  getModules(){
    let dbdata = {
      headers: new HttpHeaders({'Content-Type' : 'application/json'})
    }
    let api = '/getModel';
    this.http.get(api,dbdata).subscribe((res:any)=>{
      this.moduleData = res;
    })
  }
}
